export default __webpack_public_path__ + "static/media/JP.13f323b4.svg";